globalThis.Browser = class Browser {
  constructor() {
    document.title = "Platfo | Browser";
    document.body.id = "browser";
    this.abort = new AbortController();
    this.profile_editor = new ProfileEditor();
    this.local_worlds = new WorldList({
      title: "Local Saves",
      worlds: Object.values(globalThis.STORE.saves),
      control: [
        {
          title: "New World",
          onclick: () => globalThis.ROUTER.goto("/local/"),
        },
      ],
    });
    document.body.append(this.profile_editor.div, this.local_worlds.div);
    addEventListener("store", this.onStore.bind(this), this.abort);
  }

  remove() {
    this.abort.abort();
    this.profile_editor.remove();
    this.local_worlds.remove();
    document.body.id = "";
  }

  onStore(event) {
    switch (event.detail) {
      case "saves":
        this.local_worlds.setWorlds(Object.values(globalThis.STORE.saves));
        break;
    }
  }
};
